import { TIMEOUT_HIDDEN_TOAST_MESSAGE } from "components/ToastMessage/ToastMessage";
import { useCallback, useMemo, useState } from "react";
import { INIT_TOAST_MESSAGE } from "../constants";
import { wait } from "utils/others";

const useToastMessage = props => {
    const { message, timeoutToHideAfterShow } = props || {
        message: "",
        timeoutToHideAfterShow: null
    }
    //#region States
    const [toastMessage, setToastMessage] = useState({ 
        ...INIT_TOAST_MESSAGE,
        message
    });
    //#endregion
    //#region Functions
    const hide = useCallback(() => {
        setToastMessage(prev => ({
            ...prev,
            hidden: true
        }));
    }, []);
    const show = useCallback(async (newMessage = message, variant = null, milis = null) => {
        const newValue = {
            hidden: false,
            message: newMessage || "" ,
            variant
        };
        setToastMessage({ ...newValue });
        await wait(milis || timeoutToHideAfterShow || TIMEOUT_HIDDEN_TOAST_MESSAGE);
        newValue.hidden = true;
        setToastMessage({ ...newValue });
    }, [message, timeoutToHideAfterShow]);
    const toggleHidden = useCallback(() => {
        setToastMessage(prev => ({
            ...prev,
            hidden: !prev.hidden
        }));
    }, []);
    //#endregion
    return useMemo(() => ({
        value: {
            ...toastMessage,
            toggleHidden
        },
        hide,
        show
    }), [toastMessage, toggleHidden, hide, show]);
}

export default useToastMessage;
